import { UserRoleCode } from "./constants";
import { IUserSubscription } from "../user-subscriptions/types";

export enum SocialPlatform {
    GOOGLE = 'google',
    APPLE = 'apple',
    FACEBOOK = 'facebook'
}

export interface SocialAccount {
    platform: SocialPlatform;
    userId: string;
    reference: string;
    _id: string;
}

export interface ICustomer {
    createdAt: string;
    email: string;
    isActive: boolean;
    isDeleted: boolean;
    loginCount: number;
    name: string;
    phoneNumber: string | number;
    roleCode: UserRoleCode;
    roleName: string;
    roleValue: number;
    updatedAt: string;
    _id: string;
    profilePicture: string;
    customerId: string;
    socialAccounts?: SocialAccount[];
    lastLoggedIn?: string;
    activeSubscriptions?: Pick<IUserSubscription, 'activatedSubscription' | 'startDate' | 'endDate'>[];
    purchaseHistories?: IUserSubscription[];
}